
<div class="col">
  <br />
  <h1 class="text-center">We are currently processing your application. This may take several minutes.</h1>

  <hr>
  <p class="header-4 text-center text-muted block"><span class="timer-wrapper"><i class="fas fa-hourglass-half"></i> Time elapsed: {{counter}}</span></p>
 
  <div class="row justify-content-center">
    <div class="col-12 col-md-10">
        <p class="header-3 text-center text-wrapper">
          <em></em></p>
    </div>
</div>
 <!-- spinner -->
  <div class="spinner-wrapper text-center" [ngClass]="{'show': processing}">
    <mat-progress-spinner [mode]="'indeterminate'"></mat-progress-spinner>
  </div><!-- /spinner -->  
  

</div>

